(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[283],{

/***/ 598:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[number]",
      function () {
        return __webpack_require__(6542);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _number_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.3.1_react@17.0.2/node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(999);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/news/[number]/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n margin: 3vh 2vw 2vh;\n\n @media (max-width: 426px) {\n  margin: 2vh 4vw 3vw;\n }\n\n > h2 {\n  font-variant: small-caps;\n  font-weight: 600;\n  font-stretch: 110%;\n  color: #f70;\n }\n\n div {\n  display: flex;\n  align-items: center;\n  color: #0007;\n\n  margin: 2vh 0;\n\n  svg {\n   height: 18px;\n   width: auto;\n   color: #ddd;\n\n   margin-right: ",
        ";\n  }\n }\n\n p {\n  font-size: 0.9em;\n  line-height: 1.7;\n  text-indent: 2em;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Styling = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-23cf1a1c-0"
})(_templateObject(), function(props) {
    return props.pathname.includes('/news') ? '1%' : '2%';
});

;// CONCATENATED MODULE: ./src/pages/news/[number]/index.tsx





var title = 'Journal Aufkl\xe4rung is now supported by CAPES/CNPq';
var News = function() {
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                openGraph: {
                    title: title
                },
                title: title,
                titleTemplate: "%s"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styling, {
                pathname: pathname,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCalendarAlt */.IiJ, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "2018-11-05"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "A Revista Aufkl\xe4rung tem o prazer de comunicar sua APROVA\xc7\xc3O no Edital \"Chamada CNPq/CAPES No 26/2017 – Programa Editorial\" [441153/2017-8], no qual concorreu com centenas de outros peri\xf3dicos. Para a Revista, isto traduz todo nosso cumprimento de crit\xe9rios internacionais de qualidade na publica\xe7\xe3o cient\xedfica de conte\xfados acad\xeamicos."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Agradecemos poder estar fazendo parte deste grupo seleto de revistas que s\xe3o apoiadas diretamente pela CAPES/CNPq, \xf3rg\xe3os de apoio e financiamento \xe0 pesquisa e publica\xe7\xe3o no Brasil, e estendemos esse reconhecimento aos autores e avaliadores que nos prestigiaram de forma eficaz."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "A Revista Aufkl\xe4rung sente-se orgulhosa e manifesta sua satisfa\xe7\xe3o pelo apoio Editorial, comprometendo-se cada vez mais em seguir com seu compromisso p\xfablico de qualidade editorial."
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var _number_ = (News);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(598); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);